import { render, staticRenderFns } from "./SiteDetail.vue?vue&type=template&id=2dae3a34&scoped=true&"
import script from "./SiteDetail.vue?vue&type=script&lang=js&"
export * from "./SiteDetail.vue?vue&type=script&lang=js&"
import style0 from "./SiteDetail.vue?vue&type=style&index=0&id=2dae3a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae3a34",
  null
  
)

export default component.exports